///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const FilterIcon = ({
  title = messages.filter.defaultMessage,
  ...rest
}) => (
  <svg
    aria-labelledby="filter-icon"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title id="filter-icon">{title}</title>
    <defs>
      <path
        d="M5.833 10.5h2.334V9.333H5.833V10.5zm-4.083-7v1.167h10.5V3.5H1.75zM3.5 7.583h7V6.417h-7v1.166z"
        id="filter-icon-path"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h14v14H0z" />
      <mask id="filter-icon-mask" fill="#fff">
        <use xlinkHref="#filter-icon-path" />
      </mask>
      <use fill="#000" xlinkHref="#filter-icon-path" />
      <g mask="url(#filter-icon-mask)" fill="#000">
        <path d="M0 0h14v14H0z" />
      </g>
    </g>
  </svg>
);

export default FilterIcon;
